import { ClosedPeriodListSearchCriteria } from '../models';

interface RelationIds {
  compartmentId: number;
  dockId: number;
}

export class ClosedPeriodListLoad {
  public static readonly type = '[ClosedPeriodList] Load';
  constructor(
    public payload: RelationIds & {
      searchCriteria: ClosedPeriodListSearchCriteria;
    },
  ) {}
}

export class ClosedPeriodListInitialState {
  public static readonly type = '[ClosedPeriodList] Set initial state';
}
